import { useQueryClient } from "@tanstack/react-query";

import { signOut } from "../lib/auth";

/** Drop all subject-scoped server state before leaving the OIDC session. */
export function useLogout(): () => void {
  const queryClient = useQueryClient();
  return () => {
    queryClient.clear();
    void signOut();
  };
}
